// extracted by mini-css-extract-plugin
module.exports = {"element":"loading_element__Gb3N2","fadeIn":"loading_fadeIn__ZTJjH"};